import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import FormikWizard from 'formik-wizard';
import steps from './steps';
import Header from '../../../common/components/Header/Header';
import classes from './index.module.css';
import { isLoggedIn } from '../../../common/utils/cookie-utils';
import { getLocalStorage } from '@fincity-frontend/shared-ui';

function FormWrapper({ children, canGoBack, currentStep, wizard, steps }) {
  const [itsCreditReportFlow, setCreditReportFlow] = useState(
    window.location.pathname === '/user/request'
  );

  let isLoggedin = isLoggedIn();
  let localLogin = JSON.parse(localStorage.getItem('login'));
  let isCreditScore = getLocalStorage('creditScore');

  useEffect(() => {
    if (itsCreditReportFlow) {
      if (isCreditScore && !(parseInt(isCreditScore) <= 0)) {
        navigate('/user/request/credit-report');
      } else wizard.push(steps.find((_, i) => i === 2));
    }
  }, []);

  if (isLoggedin && currentStep === 'otp' && localLogin) {
    navigate('/user/home');
    return null;
  } else {
    if (!canGoBack) return children;
    else
      return (
        <div className="w-full overflow-auto scrolling-auto ">
          {!itsCreditReportFlow ? <Header bgWhite /> : null}
          <div
            className={
              classes.innerDiv +
              ' w-full md:mb-5 max-w-2xl  md:max-w-none md:min-w-150  rounded-md shadow-none md:shadow-md  md:bg-white mx-auto mt-0 md:mt-8 font-roboto font-medium box-border overflow-auto p-5 md:p-8 md:pb-0  md:h-auto'
            }
            style={{
              minHeight: '500px',
            }}
          >
            {children}
          </div>
        </div>
      );
  }
}

function App() {
  const handleSubmit = React.useCallback((values) => {
    navigate('/user/request/credit-report');
    return {
      message: 'Thanks for submitting!',
    };
  }, []);

  return (
    <FormikWizard steps={steps} onSubmit={handleSubmit} render={FormWrapper} />
  );
}

export default App;
